export const MODELS = {
  ImportHistoryLogs: 'ImportHistoryLogs',
  AVGenerationHistory: 'AVGenerationHistory',
  SubscriptionHistory: 'SubscriptionHistory',
  EMPLOYEETYPE: 'employeeType',
  USER: 'User',
  CONFIGURATION: 'configurations',
  EMPLOYEE: 'employees',
  ADMIN: 'Admin',
  Dealer: 'Dealer',
  SUBSCRIPTION: 'Subscription',
  APPRAISE_EMPLOYEE: 'Employee',
  Admin: 'Admin',
  CarMaker: 'CarMaker',
  AVRulesModel: 'AVRulesModel',
  UsedCarInventory: 'UsedCarInventory',
  UCIReport: 'UCIReport',
  CDKVehicle: 'CDKVehicle',
  CDKRepairOrder: 'CDKRepairOrder',
  MailOfferCount: 'MailOfferCount',
  SMSOfferCount: 'SMSOfferCount',
  PrintOfferCount: 'PrintOfferCount',
  AVFailCount: 'AVFailCount',
  ARCDKModel: 'AppraisalResultCDK',
  ManageNoti:'NotificationsUnsubs'
};

export const ROUTES = {
  emailOfferList: {
    name: 'email-offer-generated-list',
  },
  emailOfferListSA: {
    name: 'email-offer-generated-list-sa',
  },
  smsOfferList: {
    name: 'sms-offer-generated-list',
  },
  smsOfferListSA: {
    name: 'sms-offer-generated-list-sa',
  },
  printOfferList: {
    name: 'print-offer-generated-list',
  },
  printOfferListSA: {
    name: 'print-offer-generated-list-sa',
  },
  avFailList: { name: 'av-fail-generated-list' },
  avFailListSA: { name: 'av-fail-generated-list-sa' },
  fiSaleClosedList: {
    name: 'ro-open-list',
  },
  fiSaleClosedView: {
    name: 'ro-open-view',
  },
  uciReportList: {
    name: 'uci-report-list',
  },
  uciReportListWithBackButton: {
    name: 'uci-report-list-with-back',
  },
  uciReportView: {
    name: 'uci-report-view',
  },
  uciReportPrint: {
    name: 'uci-report-print',
  },
  uciReportEmptyView: {
    name: 'uci-report-emptyview',
  },
  uciListAll: {
    name: 'uci-list-all',
  },
  viewUciAllDetails: {
    name: 'view-uci-all-details',
  },
  uciListDealerSpecific: {
    name: 'uci-list-dealer-specific',
  },
  uciListDealerSpecificWithBack: {
    name: 'uci-list-dealer-specific-back',
  },
  viewUciDetailsDealerSpecific: {
    name: 'view-uci-details-dealer-specific',
  },
  checkAppraisal: {
    name: 'check-appraisal',
  },
  checkAppraisalManually: {
    name: 'check-appraisal-manually',
  },
  masterData: {
    name: 'master-data',
  },
  avRulesListSA: {
    name: 'av-rules-list',
  },
  avRulesListDealer: {
    name: 'av-rules-list-for-dealer',
  },
  avRuleAdd1: {
    name: 'av-rule-add-1',
  },
  avRuleEdit: {
    name: 'av-rule-edit',
  },
  avRuleEditDealer: { name: 'av-rule-edit-dealer' },
  avRulesView: {
    name: 'av-rules-view',
  },
  avRulesViewDealer: {
    name: 'av-rules-view-for-dealer',
  },
  subscriptionHistoryListAll: {
    name: 'subscription-histoy-list-all',
  },
  subscriptionHistoryListAllBackButton: {
    name: 'subscription-history-list',
  },
  viewSubscriptionHistory: {
    name: 'view-subscription-history-record',
  },
  appraisalHistoryListAll: {
    name: 'appraisal-history-list-all',
  },
  appraisalHistoryList: {
    name: 'appraisal-history-list',
  },
  viewAppraisalHistory: {
    name: 'view-appraisal-history',
  },
  payment: {
    name: 'payment',
  },
  buyPlan: {
    name: 'buy-plan',
  },
  setupDealerAccount: {
    name: 'setup-dealer-account',
  },
  WelcomeSA: {
    name: 'home',
  },
  WelcomeDealer: {
    name: 'home-for-dealer',
  },
  password: {
    name: 'password-popup',
  },
  passwordSA: {
    name: 'password-sa',
  },
  ResetPassword: {
    name: 'reset-password',
  },
  ForgotPassword: {
    name: 'forgot-password',
  },
  ChangePassword: {
    name: 'change-password',
  },
  HomeScreen: {
    name: 'home-screen',
  },
  addAdmin: {
    name: 'add-admin',
  },
  editAdmin: {
    name: 'edit-admin',
  },
  ViewAdmin: {
    name: 'view-admin',
  },
  alldealersAccountManage: {
    name: 'all-dealers-account-manage',
  },

  dealerSettings: {
    name: 'dealer-settings',
  },
  dealerSettingsBack: {
    name: 'dealer-settingb',
  },
  viewSelectedDealerAccountManage: {
    name: 'view-selected-dealer-account-manage',
  },
  adminData: {
    name: 'all-admins',
  },
  changeAdminPassword: {
    name: 'change-admin-password',
  },
  changeDealerPassword: { name: 'change-dealer-password' },
  addEmployee: {
    name: 'add-employee',
  },
  editEmployee: {
    name: 'edit-employee',
  },
  ViewEmployee: {
    name: 'view-employee',
  },
  changeEmployeePassword: {
    name: 'change-employee-password',
  },
  employeeDataSA: { name: 'employee-data-for-super-admin' },
  employeeData: {
    name: 'employee-data',
  },
  dealerData: {
    name: 'all-dealers',
  },
  superDealerData: {
    name: 'all-sub-dealers',
  },
  allDealerData: {
    name: 'all-dealers-data',
  },
  dealerConfiguration: {
    name: 'dealer-configuration',
  },
  addDealer: {
    name: 'add-dealer',
  },
  editDealer: {
    name: 'edit-dealer',
  },
  editDealerCC: { name: 'edit-dealer-cc' },
  ViewDealer: {
    name: 'view-dealer',
  },
  ViewSubDealer: {
    name: 'view-sub-dealer',
  },
  addDealerKyc: {
    name: 'add-dealer-kyc',
  },
  dealerKycData: {
    name: 'all-dealers-kyc',
  },
  ViewDealerKyc: {
    name: 'view-dealer-kyc',
  },
  editDealerKyc: {
    name: 'edit-dealer-kyc',
  },
  simpleList: {
    name: 'simple-list',
  },
  yearList: {
    name: 'year-list',
  },
  makeList: {
    name: 'make-list',
  },
  makeModelList: {
    name: 'make-model-list',
  },
  viewAppraisalResult: {
    name: 'view-appraisal-result',
  },
  ARListAvgen: {
    name: 'appraisal-result-list-avgen',
  },
  ARListUCI: {
    name: 'appraisal-result-list-uci',
  },
  SuperAdminSettings: {
    name: 'super-admin-setting',
  },
  AppraisalGeneratedListReload: {
    name: 'AppraisalGeneratedListReload',
  },
  NotificationUnsub:{
    name:"notification-unsub"
  },
  NotificationUnsubDealer:{
    name:"notification-unsub-dealer"
  },
  notiAdd: {
    name: 'notification-unsub-view',
  },
};

export const selectStatus = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
];

export const selectEmployeeStatus = [
  { label: 'Manager', value: 'manager' },
  { label: 'Employee', value: 'employee' },
];

export const selectDMS = [
  'CDK Global',
  'Dealertrack DMS',
  'Meadowland Systems Inc.',
  'Tekion',
  'PBS Systems',
  'Reynolds'
];

export const selectVMPP = ['Galves', 'Black Book'];
export const blackBookPriceType = [
  { label: 'XClean', value: 'xclean' },
  { label: 'Clean', value: 'clean' },
  { label: 'Average', value: 'avg' },
  { label: 'Rough', value: 'rough' },
];

export const selectKycStatus = ['Approved', 'Pending', 'Rejected'];
export const selectRuleType = ['Include', 'Exclude'];
export const selectRuleStatus = ['Active', 'Inactive', 'Deleted'];

export const selectAVRuleStatus = ['Active', 'Inactive', 'Deleted'];
export const selectAVRuleType = ['Include', 'Exclude'];
export const selectYearForRule = ['2022'];

export const selectQueryStatus = ['New', 'Resolved'];
export const selectActiveOrInactiveStatus = ['Active', 'Inactive', 'Deleted'];
export const selectPaymentMode = ['CASH', 'CC'];
export const selectPaymentStatus = ['Pending', 'Complete'];
